import { createContext } from 'react';

export interface ConfigMetaData {
  configVersion?: string;
  id?: string;
  name?: string;
  favicon?: {
    identifier: string;
    name?: string;
    size?: string;
    type?: string;
  };
}

interface MetaDataContextInterface {
  meta?: ConfigMetaData;
}

const MetaDataContext = createContext<MetaDataContextInterface>({
  meta: {
    configVersion: '',
  },
});

export default MetaDataContext;
